const STORAGE_PREFIX = "cehr_engagement_seen_posts";

export const ENGAGEMENT_SEEN_EVENT = "cehr:engagement-posts-seen";

const getStorageKey = (employeeId) => `${STORAGE_PREFIX}_${employeeId || "unknown"}`;

const getPostId = (post) => post?.id || post?._id || post?.postId;

export const readSeenEngagementPostIds = (employeeId) => {
  if (typeof window === "undefined" || !employeeId) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(getStorageKey(employeeId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.map((id) => `${id}`) : [];
  } catch {
    return [];
  }
};

export const hasUnreadEngagementPosts = (posts = [], employeeId) => {
  if (!employeeId) {
    return false;
  }

  const seenIds = new Set(readSeenEngagementPostIds(employeeId));
  return (posts || []).some((post) => {
    const id = getPostId(post);
    return id && !seenIds.has(`${id}`);
  });
};

export const markEngagementPostsSeen = (posts = [], employeeId) => {
  if (typeof window === "undefined" || !employeeId) {
    return;
  }

  const postIds = (posts || []).map(getPostId).filter(Boolean).map((id) => `${id}`);

  if (postIds.length === 0) {
    return;
  }

  const mergedIds = Array.from(new Set([...postIds, ...readSeenEngagementPostIds(employeeId)])).slice(0, 300);

  try {
    window.localStorage.setItem(getStorageKey(employeeId), JSON.stringify(mergedIds));
    window.dispatchEvent(
      new CustomEvent(ENGAGEMENT_SEEN_EVENT, {
        detail: { employeeId, seenPostIds: postIds },
      }),
    );
  } catch {
    // Storage may be unavailable in private browsing; the feed should still work.
  }
};
